import React, { useState, useRef, useEffect } from "react";
import logo from "../Assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorModel } from "../Model/ErrorModel";
import { SuccessModel } from "../Model/SuccessModel";
import { ResendOtp } from "../Redux/Slice/Authentication/ResendOtpSlice";
import { OtpVerificationIcon } from "../Assets/svgs/OtpVerificationIcon";
import { VerifyMFA } from "../Redux/Slice/Authentication/VerifyMFASlice";
import { setMFA } from "../Redux/Slice/Authentication/setMFASlice";
import { Loader } from "../Common/Loader";
import { ConfirmModel } from "../Model/ConfirmModel";
import { saveCurrentUserData } from "../Redux/Slice/Common/CurrentUserSlice";
import { VerifyOtp } from "../Redux/Slice/Authentication/VerufyOTPSlice";
import EmailVerifyIcon from "../Assets/svgs/EmailVerifyIcon";
import { formatOtpTime, maskEmail } from "../Common/utils";

export const OtpVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const otpToken = location?.state?.otpToken;
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [tab, setSelectedTab] = useState(1);
  const [timeLeft, setTimeLeft] = useState(120);
  const [userDetail, setUserDetails] = useState({});
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModal, setSuucessModal] = useState(false);
  const [successMessage, setSuucessMessage] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const redirectUrl = location?.state?.redirectUrl;

  const [backupCodes, setBackUpCodes] = useState();
  const [email2, setEmail] = useState(location?.state?.email);
  const inputRefs = useRef([
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
  ]);

  // useEffect(() => {
  //   if (timeLeft <= 0) {
  //     return;
  //   }
  //   const intervalId = setInterval(() => {
  //     setTimeLeft((prevTime) => prevTime - 1);
  //   }, 1000);

  //   return () => clearInterval(intervalId);
  // }, [timeLeft]);

  // useEffect(()=>{
  //   if(location?.state?.isMfaEnabled === true){
  //     setQR();
  //   }
  // },[location])

  // const setQR = async () => {
  //   const result = await dispatch(setMFA({ email: location?.state?.email }));
  //   if (setMFA.fulfilled.match(result) && result?.payload?.success === true) {
  //     setBackUpCodes(result?.payload?.data?.backupCodes)
  //   }
  // };

  const userData = useSelector((state) => state.login.userData);
  const newUserData = useSelector((state) => state.signUp.userData);
  const forgotPasswordUserData = useSelector(
    (state) => state.forgotPassword.userData
  );

  const userCode = useSelector((state) => state.setmfa.userData);
  useEffect(() => {
    if (userData) {
      setUserDetails(userData?.data);
      setForgotPassword(false);
    } else if (newUserData) {
      setUserDetails(newUserData?.data);
      setForgotPassword(false);
    } else if (forgotPasswordUserData) {
      setUserDetails(forgotPasswordUserData?.data);
      setForgotPassword(false);
    }
    if (location?.state?.email) {
      setUserDetails((prevData) => ({
        ...prevData,
        email: location.state.email,
      }));
    }
    if (location?.state?.reset === true) {
      setForgotPassword(true);
    }
  }, [userData, newUserData, forgotPasswordUserData]);

  const handleChangeOtp = (index, value) => {
    // Only allow numeric values
    if (!/^\d*$/.test(value)) {
      return;
    }
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to the next input field
    if (value !== "") {
      if (index < 5) {
        inputRefs.current[index + 1].current.focus();
      }
    } else {
      // Move to the previous input field if backspace and the current field is empty
      if (index > 0) {
        inputRefs.current[index - 1].current.focus();
      }
    }
  };

  const resendOtp = async () => {
    const result = await dispatch(ResendOtp({ email: location?.state?.email }));
    if (
      ResendOtp.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setTimeLeft(120);
      setUserDetails((prevData) => ({
        ...prevData,
        otpToken: result?.payload?.data?.otpToken,
      }));
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    const newOtp = [...otp];
    for (let i = 0; i < pasteData.length; i++) {
      newOtp[i] = pasteData[i];
    }
    setOtp(newOtp);

    // Focus the last input filled by paste
    if (pasteData.length < 6) {
      inputRefs.current[pasteData.length].current.focus();
    } else {
      inputRefs.current[5].current.focus();
    }
  };

  const handleSubmitOTP = async () => {
    let value = "";
    otp.forEach((x) => (value = value + `${x}`));
    const user = otpToken
      ? {
          email: location.state.email,
          otp: value,
          otpToken: otpToken,
        }
      : {
          token: value,
          email: location.state.email,
          // backupCode: location.state.backUpCodes ? location.state.backUpCodes[0] : backupCodes[0],
        };
    setIsLoading(true);
    const action = otpToken ? VerifyOtp : VerifyMFA;
    const result = await dispatch(action(user));
    if (action.fulfilled.match(result) && result?.payload?.success === true) {
      setIsLoading(false);
      if (forgotPassword) {
        navigate("/resetPassword", {
          state: { email: location.state.email, otp: value, from: true },
        });
      } else if (tab === 1) {
        localStorage.setItem("userData", JSON.stringify(result.payload.data));
        dispatch(saveCurrentUserData(result?.payload?.data));
        setSuucessMessage("Account Verified Successfully!");
        setSuucessModal(true);
        setTimeout(() => {
          if (result.payload.data.role.name === "superadmin") {
            navigate(redirectUrl ?? "/dashboard");
          } else {
            const isPaymentMethodAdded = result?.payload?.data?.customer
              ? result?.payload?.data?.customer?.isPaymentMethodAdded
              : true;
            if (
              location?.state?.isRedirectedFromSignup ||
              !isPaymentMethodAdded
            ) {
              navigate("/free-trial", {
                state: {
                  redirectUrl,
                }
              });
            } else {
              navigate(redirectUrl ?? "/dashboard");
            }
          }
        }, 1500);
        // setSelectedTab(2);
        // setOtp(["", "", "", "", "", ""]);
        // setTimeLeft(120);
      }
      // navigate("/billing");
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModal(true);
      setTimeout(() => {
        setOtp(["", "", "", "", "", ""]);
        setErrorModal(false);
      }, 1500);
    }
  };

  useEffect(() => {
    if (timeLeft <= 0) {
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  return (
    <section className="layoutContainer layoutContainer--full">
      {isLoading ? <Loader /> : ""}
      <div className="layoutGrid">
        <div className="page page--loginOtp">
          <div className="page__head">
            <div className="page__head__logo">
              <img src={logo} alt="Logo | Vox App" />
            </div>
          </div>
          <div className="page__body">
            <div className="emailVerificationCard emailVerificationCard--twoFactorAuthentication">
              <div className="branding">
                <div className="branding__info textCenter">
                  <h1 className="title title--h1">
                    {otpToken
                      ? "OTP Verification"
                      : "Two Factor Authentication"}
                  </h1>
                  {otpToken ? <br /> : null}
                  <p className="text">
                    {otpToken
                      ? `Please enter the code sent to\n${maskEmail(
                          location.state?.email
                        )}`
                      : "Waiting For Approval"}
                  </p>
                </div>
                <div className="branding__icon">
                  {otpToken ? <EmailVerifyIcon /> : <OtpVerificationIcon />}
                </div>
              </div>
              <div className="emailVerificationCard__form">
                <div className="form__group">
                  <div className="form__group__flex form__group--otp">
                    {otp.map((value, index) => (
                      <input
                        key={index}
                        type="text"
                        id={`otp${index + 1}`}
                        className="form__input"
                        maxLength="1"
                        value={value}
                        ref={inputRefs.current[index]}
                        onChange={(e) => handleChangeOtp(index, e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" && !otp[index]) {
                            handleChangeOtp(index, "");
                          }
                        }}
                        onPaste={handlePaste}
                      />
                    ))}
                  </div>
                </div>
                <h4 className="title title--h5 textCenter">
                  Type your 6 digit security code
                </h4>
                <div className="form__button textCenter">
                  <button
                    className="btn btn__primary btn--full"
                    onClick={handleSubmitOTP}
                    type="submit"
                    disabled={
                      otp[0] == "" ||
                      otp[1] == "" ||
                      otp[2] == "" ||
                      otp[3] == "" ||
                      otp[4] == "" ||
                      otp[5] == ""
                    }
                  >
                    Submit
                  </button>
                  {otpToken ? (
                    <div className="form__optInfo">
                      {timeLeft !== 0 ? (
                        <p className="para">
                          Didn’t get the code?{" "}
                          <div className="link">{formatOtpTime(timeLeft)}</div>
                        </p>
                      ) : null}
                      <p className="para">
                        <a
                          to="#"
                          className={
                            timeLeft !== 0
                              ? "link link--disabled"
                              : "link link--underline"
                          }
                          onClick={resendOtp}
                        >
                          Resend OTP
                        </a>
                      </p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {errorModal ? <ErrorModel message={errorMessage} /> : ""}
      {successModal ? <SuccessModel message={successMessage} /> : ""}
    </section>
  );
};
